import type { Module } from "vuex/types/index.d.ts";
import { $api } from "@/services/api";
import type { CustomText } from "@/models/custom";

const customTextModule: Module<any, any> = {
  namespaced: true,
  state: {
    customTexts: [] as CustomText[],
  },
  mutations: {
    SET_CUSTOM_TEXT(state: any, customTexts: CustomText[]) {
      state.customTexts = customTexts;
    },
  },
  actions: {
    async getCustomTexts({ commit }, payload: any) {
      const results = await $api.custom.getCustomTexts(
        payload.lid,
        payload.programTypeId,
        payload.productTypeId,
        payload.flowType,
      );

      commit("SET_CUSTOM_TEXT", results);
    },
  },
};

export default customTextModule;
